import { ChoiceGroup, IconButton } from "@fluentui/react";
import * as React from "react";
import { useContext, useEffect, useState } from "react";
import { Outlet, useNavigate, useOutletContext, useParams } from "react-router-dom";
import AppContent from "../Surfaces/AppContent";
import AuthContext from "../Services/AuthContext";
import DeleteVenture from "../Panel/Venture/DeleteVenture";
import { formatBankAccountNumber } from "../Utilities/formatBankAccountNumber";
import { clearTextInfo, joinTextInfo } from "../Utilities/clearTextInfo";
import EditVenture from "../Panel/Venture/EditVenture";

function Venture() {
    const [user] = useContext(AuthContext);
    const [venture, setVenture] = useState(null);
    const [refresh, setRefresh] = useState(0);
    const [editVenture, setEditVenture] = useState(false);

    const params = useParams();
    useEffect(() => {
        const abortController = new AbortController();
        async function fetchData2() {
            await fetch(`/api/venture/${params.id}/data`, {
                method: 'GET',
                signal: abortController.signal,
                headers: {
                    'Authorization': 'Bearer ' + user.token
                }
            }).then(res => res.json())
                .then(data => {
                    setVenture({
                        id: params.id,
                        name: data.venture,
                        buffer_account: data.buffer_account,
                        series: data.series,
                        identification: data.identification,
                        description: data.description,
                        company_id: data.company_id,
                        status: data.status,
                    });
                })
                .catch(err => { console.log(err) })
        }
        fetchData2();
        return () => abortController.abort();
    }, [params.id, refresh, user.token]);
    let navigate = useNavigate();
    const actions = useOutletContext();

    const options = [
        {
            key: 'project',
            text: 'Projekty',
            iconProps: { iconName: 'Library' },
        },
        {
            key: 'cost',
            text: 'Koszty',
            iconProps: { iconName: 'Money' },
        },
        {
            key: 'document',
            text: 'Pliki',
            iconProps: { iconName: 'Documentation' },
        },
        {
            key: 'template',
            text: 'Wzory',
            iconProps: { iconName: 'FileTemplate' },
        },
        {
            key: 'addon',
            text: 'Dodatki',
            iconProps: { iconName: 'WebAppBuilderFragment' },
        },
        {
            key: 'milestone',
            text: 'Kamienie Milowe',
            iconProps: { iconName: 'Timeline' },
        },
        {
            key: 'payment',
            text: 'Prognoza Płatności',
            iconProps: { iconName: 'FinancialSolid' },
        },
    ];

    const subtitle = [
        clearTextInfo(formatBankAccountNumber(venture?.buffer_account), 'Nr. Konta:'),
        clearTextInfo(venture?.series, 'Seria:'),
        clearTextInfo(venture?.identification, 'Nr. identyfikacyjny:')
    ];
    return (
        <AppContent
            title={venture?.name}
            backTo={'/'}
            subtitle={joinTextInfo(subtitle)}
            delete={(<>
                <DeleteVenture id={params.id} onSuccess={() => navigate(`/`)} />
                <IconButton iconProps={{iconName: 'Edit'}} title={'Edytuj Kontrakt'} onClick={() => setEditVenture(venture)} />
            </>)}
        >
            <ChoiceGroup defaultSelectedKey="project" options={options} onChange={(e, val) => navigate(`/venture/${params.id}/${val.key}`)}/>
            <Outlet context={{actions: actions}}/>
            <EditVenture edit={editVenture} dismissPanel={() => setEditVenture(false)} onSuccess={() => setRefresh(refresh + 1)} />

        </AppContent>
    );
}

export default Venture;